/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ServiceVersionDto } from './ServiceVersionDto';
import {
    ServiceVersionDtoFromJSON,
    ServiceVersionDtoFromJSONTyped,
    ServiceVersionDtoToJSON,
} from './ServiceVersionDto';

/**
 * 
 * @export
 * @interface ServiceVersionsDto
 */
export interface ServiceVersionsDto {
    /**
     * The service versions.
     * @type {Array<ServiceVersionDto>}
     * @memberof ServiceVersionsDto
     */
    items: Array<ServiceVersionDto>;
}

/**
 * Check if a given object implements the ServiceVersionsDto interface.
 */
export function instanceOfServiceVersionsDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "items" in value;

    return isInstance;
}

export function ServiceVersionsDtoFromJSON(json: any): ServiceVersionsDto {
    return ServiceVersionsDtoFromJSONTyped(json, false);
}

export function ServiceVersionsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceVersionsDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(ServiceVersionDtoFromJSON)),
    };
}

export function ServiceVersionsDtoToJSON(value?: ServiceVersionsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(ServiceVersionDtoToJSON)),
    };
}

